// hooks/useOpportunityStatus.ts
import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { IOpportunityStatus } from '../types/opportunityStatus';

export const useOpportunityStatus = () => {
    const [statusOportunidades, setStatusOportunidades] = useState<IOpportunityStatus[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchStatusOportunidades = async () => {
        try {
            setLoading(true);
            const response = await apiService.getStatusOportunidades();
            setStatusOportunidades(response.data);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar status de oportunidades. Por favor, tente novamente.');
            console.error('Erro ao buscar status de oportunidades:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStatusOportunidades();
    }, []);

    return {
        statusOportunidades,
        loading,
        error,
        refetchStatusOportunidades: fetchStatusOportunidades
    };
};
